import { store } from '../redux/store';
import { Translation } from '../api';

export const getLabel = (key: string): Translation => {
  return findTranslation(key);
};

/**
 * Ersetzt die Platzhalter einer Translation, wenn es die gibt.
 * z.B. in der Translation "Auftrag mit Nummer. {1} wurde gespeichert wuerde {1}
 * ersetzt mit den ersten Wert des placeholderValues array. Falls es mehr als ein
 * platzhalter gibt, wird die Methode selber rekursiv aufgerufen bis alle Platzhalter
 * ersetzt sind.
 *
 * @param text der Text in dem die Platzhalter ersetzt werden sollen
 * @param iteration die iteration in der recursion Schleife
 * @param placeholderValues die Platzhalter Werte
 */
export const replacePlaceholderValues = (
  text: string,
  iteration: number,
  placeholderValues: any[]
): string => {
  if (placeholderValues.length > 0) {
    text = text.replace(`{${iteration}}`, placeholderValues[0]);
    return replacePlaceholderValues(
      text,
      iteration++,
      placeholderValues.slice(1)
    );
  }
  return text;
};

/**
 * Liefert anhand des Keys die entsprechende Translation.
 * Wenn keine Translation anhand des keys gefunden wird,
 * wird eine Translation geliefert der Key selber als Bezlang, Bezkurz verwendet wird.
 * @param key der Schluessel der Translation
 */
export const findTranslation = (key: string): Translation => {
  const state = store.getState();
  const entries = state.Translation;
  const result = entries?.filter(entry => entry.key === key);
  let translation: Translation = {};
  if (result && result.length == 1) {
    translation = result[0];
  } else {
    translation.id = Math.random();
    translation.key = key;
    translation.bezkurz = key;
    translation.bezlang = key;
  }

  return translation;
};
